import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('LinkRequest', LinkRequestData);

    LinkRequestData.$inject = ['$filter' ,'$translate'];

    /* @ngInject */
    function LinkRequestData($filter ,$translate) {
        LinkRequest.prototype = {
            build: build,
            buildEmpty: buildEmpty,
        };

        function LinkRequest(linkRequestData) {
            if (!linkRequestData) {
                this.buildEmpty();
            } else {
                this.build(linkRequestData);
            }
        }

        return LinkRequest;

        function buildEmpty() {
            this.buyerName = null;
            this.communityName = null;
            this.sellerName =null;
            this.buyerSubEntityName = null;
            this.sellerSubEntityName = null;
            this.codeErp = null;
            this.cooperativeName = null;
            this.responseDate = null;
            this.creationDate = null;
            this.enabledServices = null;
            this.status = null;
        }

        function build(linkRequestData) {
            this.communityName = linkRequestData.communityName || null;
            this.buyerName = linkRequestData.buyerName || null;
            this.sellerName = linkRequestData.sellerName || null;
            this.buyerSubEntityName = linkRequestData.buyerSubEntityName || null;
            this.sellerSubEntityName = linkRequestData.sellerSubEntityName || null;
            this.codeErp = linkRequestData.codeErp || null;
            this.cooperativeName = linkRequestData.cooperativeName || null;
            this.creationDate = linkRequestData.creationDate ? $filter('date')(linkRequestData.creationDate, 'shortDate') :  null;
            this.status = $translate.instant('link_request.status.' + angular.lowercase(linkRequestData.status));
            this.responseDate = linkRequestData.responseDate ? $filter('date')(linkRequestData.responseDate, 'shortDate') :  null;
            this.enabledServices = getEnableService(linkRequestData);
        }

        function getEnableService(linkRequestData){
            var val = '';
            if(linkRequestData.serviceInvoiceEnabled)
            {
                val= $translate.instant('principal.invbuy_enabled_service.' + "invoice");
            }
            if(linkRequestData.serviceOrderEnabled)
            {
              val= val!=='' ? val + " + " +$translate.instant('principal.invbuy_enabled_service.' + "order")
                  : $translate.instant('principal.invbuy_enabled_service.' + "order");
            }
            if(linkRequestData.serviceGEDEnabled)
            {
                val= val==='' ? $translate.instant('principal.invbuy_enabled_service.' + "documentation_space")
                    : val + " + " +$translate.instant('principal.invbuy_enabled_service.' + "documentation_space") ;

            }
            return val;
        }
    }
})();
